// Generated by branding/generate.mjs from branding/rhysomn.svg.
// Lucide ISC attribution: public/brand-license.txt.
import type { Html, HtmlBuilder } from "foldkit/html";
import type { IconOptions } from "./icons";

export const BrandLogo = <M>(
	h: HtmlBuilder<M>,
	{ size = 24, class: className = "" }: IconOptions = {},
): Html =>
	h.svg(
		[
			h.Attribute("xmlns", "http://www.w3.org/2000/svg"),
			h.Width(String(size)),
			h.Height(String(size)),
			h.ViewBox("0 0 24 24"),
			h.Fill("none"),
			h.Stroke("currentColor"),
			h.StrokeWidth("1.9"),
			h.StrokeLinecap("round"),
			h.StrokeLinejoin("round"),
			h.Class(className),
			h.AriaHidden(true),
			h.Attribute("focusable", "false"),
		],
		[
			h.path([h.Attribute("d", "M20.268 11.277 A8.3 8.3 0 1 1 12.723 3.732")]),
			h.path([h.Attribute("d", "M13.838 10.162 L17.233 6.767")]),
			h.circle([
				h.Attribute("cx", "12.000"),
				h.Attribute("cy", "12.000"),
				h.Attribute("r", "2.6"),
			]),
			h.circle([
				h.Attribute("cx", "19.212"),
				h.Attribute("cy", "4.788"),
				h.Attribute("r", "2.8"),
			]),
			h.circle([
				h.Attribute("cx", "12.000"),
				h.Attribute("cy", "12.000"),
				h.Attribute("r", "0.65"),
				h.Attribute("fill", "currentColor"),
				h.Attribute("stroke", "none"),
			]),
		],
	);
